export const chargeManagementPath = (chargeId: number) =>
  `/scrap-charges/${chargeId}`;
